import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../../app/api/apiSlice";

const transportTypesAdapter = createEntityAdapter({});

const initialState = transportTypesAdapter.getInitialState();

export const transportTypesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTransportTypes: builder.query({
      query: () => "/transportTypes",
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
      // keepUnusedDataFor: 5,
      transformResponse: (responseData) => {
        const loadedTransportTypes = responseData.map((transportType) => {
          transportType.id = transportType._id;
          return transportType;
        });
        return transportTypesAdapter.setAll(initialState, loadedTransportTypes);
      },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "TransportType", id: "LIST" },
            ...result.ids.map((id) => ({ type: "TransportType", id })),
          ];
        } else return [{ type: "TransportType", id: "LIST" }];
      },
    }),
    addNewTransportType: builder.mutation({
      query: (initialTransportTypeData) => ({
        url: "/transportTypes",
        method: "POST",
        body: {
          ...initialTransportTypeData,
        },
      }),
      invalidatesTags: [{ type: "TransportType", id: "LIST" }],
    }),
    updateTransportType: builder.mutation({
      query: (initialTransportTypeData) => ({
        url: "/transportTypes",
        method: "PATCH",
        body: {
          ...initialTransportTypeData,
        },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "TransportType", id: arg.id },
      ],
    }),
    deleteTransportType: builder.mutation({
      query: ({ id }) => ({
        url: `/transportTypes`,
        method: "DELETE",
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "TransportType", id: arg.id },
      ],
    }),
  }),
});

export const {
  useGetTransportTypesQuery,
  useAddNewTransportTypeMutation,
  useUpdateTransportTypeMutation,
  useDeleteTransportTypeMutation,
} = transportTypesApiSlice;

// // returns the query result object
// export const selectTransportTypesResult =
//   transportTypesApiSlice.endpoints.getTransportTypes.select();

// // creates memoized selector
// const selectTransportTypesData = createSelector(
//   selectTransportTypesResult,
//   (transportTypesResult) => transportTypesResult.data // normalized state object with ids & entities
// );

// //getSelectors creates these selectors and we rename them with aliases using destructuring
// export const {
//   selectAll: selectAllTransportTypes,
//   selectById: selectTransportTypeById,
//   selectIds: selectTransportTypeIds,
//   // Pass in a selector that returns the transportTypes slice of state
// } = transportTypesAdapter.getSelectors(
//   (state) => selectTransportTypesData(state) ?? initialState
// );
